<div class="aside-section">
  <app-document-number-info
    [documentType]="documentType"
    [documentNumber]="documentNumber"
  >
  </app-document-number-info>

  <app-document-status
    class="document-status"
    [documentType]="documentType"
    [documentState]="documentState"
    [documentCalculationResult]="documentCalculationResult"
    [featureToggles]="featureToggles"
    [showRecurringIcon]="enableRecurring && !!documentSchedule?.interval"
  >
  </app-document-status>

  <app-estimate-status
    *ngIf="documentType === DocumentTypesEnum.estimate"
    class="estimate-status"
    [documentState]="documentState"
  >
  </app-estimate-status>

  <app-document-balance-breakdown
    class="document-balance-breakdown"
    [documentCalculationResult]="documentCalculationResult"
    [currencyCode]="documentSettings?.currencyCode"
    [locale]="documentSettings?.locale"
    [showTotal]="showTotal"
    [useOutstandingBalance]="useOutstandingBalance"
    [showPaid]="showPaid"
  >
  </app-document-balance-breakdown>

  <app-document-link
    *ngIf="sourceDocumentPreview"
    [documentPreview]="sourceDocumentPreview"
    [labelKey]="sourceLabelKey"
    class="document-link"
  >
  </app-document-link>

  <app-document-link
    *ngIf="linkedDocumentPreview"
    [documentPreview]="linkedDocumentPreview"
    [labelKey]="linkedLabelKey"
    class="document-link"
  >
  </app-document-link>

  <app-document-payment-actions
    [documentDataDispatcher]="documentDataDispatcher"
    [documentId]="documentId"
    [documentDueDate]="documentDueDate"
    [documentState]="documentState"
    [documentType]="documentType"
    [documentFeatureName]="documentFeatureName"
    [documentCalculationResult]="documentCalculationResult"
    [documentPaymentUrl]="documentPaymentUrl"
    [documentSettings]="documentSettings"
    [documentBilling]="documentBilling"
    [documentPayments]="documentPayments"
    [companySettings]="companySettings"
    [paymentsSettings]="paymentsSettings"
    [documentTrackingObject]="documentTrackingObject"
    [trackingScreenName]="trackingScreenName"
    [featureToggles]="featureToggles"
    [document]="document"
    [documentHasUnsavedChanges]="documentHasUnsavedChanges"
    [documentLocale]="documentSettings?.locale"
    [account]="account"
    [deposit]="deposit"
    [addDepositForFuture]="addDepositForFuture"
    [enableDeposits]="enableDeposits"
    [depositRequestFeatureName]="depositRequestFeatureName"
    [showPaymentActions]="showPaymentActions"
    (onUpdateDocumentContent)="updateDocumentContent.emit($event)"
    (onUpdateSettingsContent)="updateSettingsContent.emit($event)"
  >
  </app-document-payment-actions>

  <button
    *ngIf="showSendButton && documentType"
    type="button"
    class="send-button"
    data-e2e-id="document-send-action"
    [disabled]="disableSendButton"
    trackable
    [trackingObject]="documentTrackingObject"
    [trackingAction]="buttonSendTapped"
    [trackingAdditionalProperties]="paymentOptionsTrackingProperties"
    (click)="sendDocument.emit()"
  >
    {{ 'DOCUMENT.' + documentType + '.EMAIL.SEND' | uppercase | translate }}
  </button>
</div>

<div
  *ngIf="showBankTransfer || showCardPayments || showPaypalEc"
  class="aside-section payment-options-wrapper"
>
  <app-document-payment-options
    [documentDataDispatcher]="documentDataDispatcher"
    [paymentsSettings]="paymentsSettings"
    [documentCalculationResult]="documentCalculationResult"
    [showI2gMoney]="showI2gMoney"
    [showBankTransfer]="showBankTransfer"
    [showCardPayments]="showCardPayments"
    [showPaypalEc]="showPaypalEc"
    [paypalEcStatus]="paypalEcStatus"
    [i2gMoneyEnabled]="i2gMoneyEnabled"
    [bankTransferEnabled]="bankTransferEnabled"
    [cardPaymentsEnabled]="cardPaymentsEnabled"
    [companyCountry]="companySettings?.country"
    [underwritingUrl]="underwritingUrl"
    [paypalEcEnabled]="paypalEcEnabled"
    [documentId]="documentId"
    [documentType]="documentType"
    [remindersSettings]="remindersSettings"
    [documentSettings]="documentSettings"
    [documentBilling]="documentBilling"
    [documentTrackingObject]="documentTrackingObject"
    [trackingScreenName]="trackingScreenName"
    [paymentOptionsTrackingProperties]="paymentOptionsTrackingProperties"
    [featureToggles]="featureToggles"
    [showPaymentReminders]="showPaymentReminders"
    [account]="account"
    [deposit]="deposit"
    (savePaymentOptions)="updateDocumentContent.emit($event)"
    (growthCta)="growthCta.emit()"
  >
  </app-document-payment-options>
</div>

<!--TODO: DAPHNE Add information icon that links to the following help article: https://support.2go.com/hc/articles/228957707-->
<div *ngIf="enableSchedules" class="aside-section recurring-invoice-wrapper">
  <app-labeled-section [header]="'LABEL.RECURRING_INVOICE' | translate">
    <app-document-schedule
      [documentSchedule]="documentSchedule"
      [documentDate]="documentDate"
      [documentTrackingObject]="documentTrackingObject"
      [trackingScreenName]="trackingScreenName"
      [featureToggles]="featureToggles"
      (updateRecurringSchedule)="updateRecurringSchedule.emit($event)"
      (onGrowthCta)="growthCta.emit()"
    >
    </app-document-schedule>
  </app-labeled-section>
</div>
